export default function (key: string): number[] {
  return key
    .matchAll(/\d+/g)
    .toArray()
    .map((e) => Number(e[0]));
}
